import TextConverter from './textConverter';
import NumConverter from './numConverter';
import DateConverter from './dateConverter';
import { filterRuleEnum } from '@/constantEnum';
import dayjs from 'dayjs';

const labelFilterEnum = {
  label: '已标注案件数',
  auto: '系统规则标注',
  manual: '人工确认标注', // 已废弃，兼容旧条件
  manualEffective: '已确认内容属实',
  manualUnEffective: '已确认内容无关',
  none: '未标注案件数'
};

class Converter {
  constructor() {
    this.converterList = {
      text: new TextConverter(),
      num: new NumConverter(),
      date: new DateConverter()
    };
  }

  toTip(item, paragraphArr) {
    if (item.isTextFilter) {
      const paragraphText = item.info.selects
        .map(paragraphKey => {
          const paragraphItem = paragraphArr.find(paragraphItem => paragraphItem.key === paragraphKey);
          return (paragraphItem && paragraphItem.value) || '全文';
        })
        .join('、');
      return `${paragraphText}：${item.info.text}`;
    }
    if (item.isLabelFilter) {
      const { type, fieldDetail } = item.info;
      return `${fieldDetail.title} - ${labelFilterEnum[type]}`;
    }
    const { formData, columnInfo } = item;
    if (['DUPLICATE_COUNT', 'MONODROME', 'MULTIVALUED'].includes(formData.rule)) {
      if (formData.rule === 'DUPLICATE_COUNT') {
        return `${columnInfo.title} 重复项计数 ${formData.symbol} ${formData.num}`;
      }
      return `${columnInfo.title}${formData.rule === 'MONODROME' ? '单值' : '多值'}`;
    }

    if (columnInfo.type === 'date' && formData.rule === 'range') {
      const dateTextArr = formData.date.map(dateVal => {
        if (!dateVal) {
          return '';
        }
        return dayjs(dateVal).format('YYYY-MM-DD');
      });
      if (dateTextArr.filter(dateValStr => !!dateValStr).length === 2) {
        return `${columnInfo.title} ${dateTextArr.join(' ~ ')}`;
      } else if (dateTextArr[0]) {
        return `${columnInfo.title} 从${dateTextArr[0]}开始`;
      } else if (dateTextArr[1]) {
        return `${columnInfo.title} 截止至${dateTextArr[1]}`;
      } else {
        return columnInfo.title;
      }
    }
    const ruleTipItem = filterRuleEnum[formData.rule];
    if (columnInfo.type === 'num') {
      if (formData.rule === 'term') {
        return `${columnInfo.title} ${ruleTipItem.tip} ${formData.num}`;
      } else if (['range', 'lrange', 'rrange', 'erange'].includes(formData.rule)) {
        return `${columnInfo.title}${ruleTipItem.tip}为${formData[ruleTipItem.fieldKey][0]}-${
          formData[ruleTipItem.fieldKey][1]
        }`;
      }
    }
    if (formData.rule === 'term' && formData.keywordMode === 'remote' && (formData.keywordArr || []).length > 0) {
      return `${columnInfo.title} ${ruleTipItem.tip} ${formData.keywordArr.join('、')}`;
    }
    return `${columnInfo.title} ${ruleTipItem.tip} ${formData[ruleTipItem.fieldKey] || ''}`;
  }

  // 废弃
  toQuery(filterArr) {
    const queryObj = { must: [], must_not: [] };
    filterArr.forEach(filterItem => {
      let result;
      if (filterItem.isTextFilter) {
        result = this.formatTextFilter(filterItem);
      } else if (filterItem.isLabelFilter) {
        result = this.formatLabelFilter(filterItem);
      } else {
        const converterEL = this.converterList[filterItem.columnInfo.type];
        if (converterEL) {
          result = converterEL.toQuery(filterItem);
        }
      }
      result.must && queryObj.must.push(...result.must);
      result.must_not && queryObj.must_not.push(...result.must_not);
    });
    return queryObj;
  }

  formatTextFilter(filterItem) {
    const must = [];
    const { selects, text } = filterItem.info;
    selects.forEach(paragraphKey => {
      must.push({
        match_phrase: {
          [`${paragraphKey}`]: text
        }
      });
    });
    return { must };
  }

  formatLabelFilter(filterItem) {
    const must = [];
    const mustNot = [];
    const { type, fieldDetail } = filterItem.info;
    if (['auto', 'manual'].includes(type)) {
      must.push({
        term: {
          [`${fieldDetail.columnKey}.manual.keyword`]: type === 'auto' ? '自动' : '手动'
        }
      });
    } else if (['manualEffective', 'manualUnEffective'].includes(type)) {
      must.push({
        term: {
          [`${fieldDetail.columnKey}.manual.keyword`]: '手动'
        }
      });
      must.push({
        term: {
          [`${fieldDetail.columnKey}.effective`]: type === 'manualEffective'
        }
      });
    } else if (type === 'none') {
      mustNot.push({
        range: {
          [`${fieldDetail.columnKey}.size`]: { gte: 1 }
        }
      });
    }
    return { must, must_not: mustNot };
  }
}

export default new Converter();
